import { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import ProfileSidebar from '../components/common/Avatar/ProfileSidebar';
import StudentDetails from '../components/Placementdb/Editform/StudentDetails';
import CourseDetails from '../components/Placementdb/Editform/CourseDetails';
import PerformanceSection from '../components/Placementdb/Editform/PerformanceSection';
import ProjectsSection from '../components/Placementdb/Editform/ProjectsSection';
import Qualification from '../components/Placementdb/Editform/Qualification ';
import { useToast } from '../components/Admissionform/ToastManager';
import StaffDetails from '../components/Placementdb/Editform/StaffDetails';
import PlacementTab from '../components/Placementdb/Editform/PlacementTab';
import '../styles/StudentEntryForm.css';
import Swal from "sweetalert2";


const EditStudentRecordpp = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('studentDetails');
    const [formData, setFormData] = useState(null);
    const { showSuccess, showError } = useToast();
    const role = localStorage.getItem("role");
    const empId = localStorage.getItem("emp_id");

    const canUpdateVerification =
        role === "Super-Admin" ||
        empId === "5278";
    // Fetch student data
    const fetchStudentData = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/student-rec/${id}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.data?.data) {
                const c = response.data.data.courseDetails;
                const r = response.data.data.studentRegistration;

                const projects = [
                    { projectTitle: c.projectTitle1 || '', projectStatus: c.project1Status || '', projectScore: c.project1Score ?? 0 },
                    { projectTitle: c.projectTitle2 || '', projectStatus: c.project2Status || '', projectScore: c.project2Score ?? 0 },
                    { projectTitle: c.projectTitle3 || '', projectStatus: c.project3Status || '', projectScore: c.project3Score ?? 0 }
                ].filter(p => p.projectTitle || p.projectStatus || p.projectScore > 0);

                if (projects.length === 0) {
                    projects.push({ projectTitle: '', projectStatus: '', projectScore: 0 });
                }

                const mappedData = {
                    // 🔹 StudentRegistration Table
                    studentId: r.studentId,
                    studentName: c.studentName,
                    contactNo: r.contactNo,
                    ParentNo: r.ParentNo,
                    address: r.address,
                    dob: r.dob,
                    email: r.email_Id,
                    offerLetterPath: r.offerLetterPath,
                    lastLogin: r.lastLogin,


                    // 🔹 CourseDetails Table
                    gender: c.gender,
                    location: c.desiredlocation ? c.desiredlocation.split(",") : [],
                    courseType: c.courseType,
                    courseName: c.courseName,
                    batch: c.batch,
                    learningMode: c.learningMode,
                    Department: c.Department,
                    skillsKnown: c.knownSkill ? c.knownSkill.split(",") : [],
                    branch: c.branch,
                    mentor: c.mentor,
                    mentorNumber: c.mentorNumber,
                    staffName1: c.staffName1,
                    staffName2: c.staffName2,
                    staffName3: c.staffName3,
                    placementneeded: c.placementneeded,
                    readyForPlacement: c.readyForPlacement,
                    placementStatus: c.placementStatus,
                    courseStartDate: c.courseStartDate,
                    courseEndDate: c.courseEndDate,

                    technicalScore: c.technicalScore,
                    communicationScore: c.communicationScore,
                    technologyRemarks: c.technologyRemarks,
                    communicationRemarks: c.communicationRemarks,
                    mockInterview: c.mockInterview,
                    mockRemarks: c.mockRemarks,

                    mockTest1Score: c.mockTest1Score,
                    mockTest2Score: c.mockTest2Score,
                    mockTest3Score: c.mockTest3Score,

                    studentProgressStatus: c.ProgressStatus,
                    placementInterest: c.placementInterest,
                    staffRemarks: c.staffRemarks,

                    // 🔹 Education fields
                    tenthInstitution: c.tenthInstitution,
                    tenthDepartment: c.tenthDepartment,
                    tenthDegree: c.tenthDegree,
                    tenthPassout: c.tenthPassout,
                    tenthPercentage: c.tenthPercentage,

                    twelfthInstitution: c.twelfthInstitution,
                    twelfthDepartment: c.twelfthDepartment,
                    twelfthDegree: c.twelfthDegree,
                    twelfthPassout: c.twelfthPassout,
                    twelfthPercentage: c.twelfthPercentage,

                    diplomaInstitution: c.diplomaInstitution,
                    diplomaDepartment: c.diplomaDepartment,
                    diplomaDegree: c.diplomaDegree,
                    diplomaPassout: c.diplomaPassout,
                    diplomaPercentage: c.diplomaPercentage,

                    ugInstitution: c.ugInstitution,
                    ugDepartment: c.ugDepartment,
                    ugDegree: c.ugDegree,
                    ugPassout: c.ugPassout,
                    ugPercentage: c.ugPercentage ?? c.cgpa,

                    pgInstitution: c.pgInstitution,
                    pgDepartment: c.pgDepartment,
                    pgDegree: c.pgDegree,
                    pgPassout: c.pgPassout,
                    pgPercentage: c.pgPercentage,

                    // 🔹 Experience
                    experience: c.experience,
                    expCompanyName1: c.expCompanyName1,
                    expStartDate1: c.expStartDate1,
                    expEndDate1: c.expEndDate1,
                    expRole1: c.expRole1,
                    expTechnologies1: c.expTechnologies1,
                    expCurrentlyWorking1: c.expCurrentlyWorking1,

                    expCompanyName2: c.expCompanyName2,
                    expStartDate2: c.expStartDate2,
                    expEndDate2: c.expEndDate2,
                    expRole2: c.expRole2,
                    expTechnologies2: c.expTechnologies2,
                    expCurrentlyWorking2: c.expCurrentlyWorking2,

                    expCompanyName3: c.expCompanyName3,
                    expStartDate3: c.expStartDate3,
                    expEndDate3: c.expEndDate3,
                    expRole3: c.expRole3,
                    expTechnologies3: c.expTechnologies3,
                    expCurrentlyWorking3: c.expCurrentlyWorking3,

                    // 🔹 Placement
                    companyName: c.companyName,
                    placementStatusChangedBy: c.placementStatusChangedBy,
                    placementStatusChangedAt: c.placementStatusChangedAt,
                    companyLocation: c.companyLocation,
                    jobRole: c.jobRole,
                    placedBy: c.placedBy,
                    placementDate: c.placementDate,
                    placementRemarks: c.placementRemarks,
                    joiningDate: c.joiningDate,
                    package: c.package,
                    createdAt: c.createdAt,
                    readyForPlacementDate: c.readyForPlacementDate
                        ? new Date(c.readyForPlacementDate).toISOString().split("T")[0]
                        : "",
                    joiningStatus: c.joiningStatus,
                    verificationRemarks: c.verificationRemarks,
                    verificationUpdatedBy: c.verificationUpdatedBy,
                    verificationUpdatedAt: c.verificationUpdatedAt,

                    photoReview: c.photoReview,
                    photoReviewLink: c.photoReviewLink,
                    photoReviewReason: c.photoReviewReason,
                    videoReview: c.videoReview,
                    videoReviewLink: c.videoReviewLink,
                    videoReviewReason: c.videoReviewReason,
                    googleReview: c.googleReview,
                    googleReviewStars: c.googleReviewStars,
                    googleReviewReason: c.googleReviewReason,

                    projects
                };

                setFormData(mappedData);
            }
        } catch (error) {
            console.error('Error fetching student record:', error);
            showError('Failed to fetch student record');
        }
    };
    useEffect(() => {
        fetchStudentData();
    }, [id]);

    const handleDepartmentChange = (selectedDept) => {
        console.log('Department changed to:', selectedDept);
        setFormData(prev => ({
            ...prev,
            department: selectedDept
        }));
    };

    const handleSkillsChange = (selectedSkills) => {
        console.log('Skills changed to:', selectedSkills);
        setFormData(prev => ({
            ...prev,
            skillsKnown: selectedSkills
        }));
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.placementStatus === "Placed") {
            const pkg = Number(formData.package || 0);

            if (pkg < 100000) {
                const confirm = await Swal.fire({
                    title: "Annual Package(LPA) is very low!",
                    text: "Mention the salary in LPA. Salary Package is very low and this cannot be considered as Placement",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes, continue",
                    cancelButtonText: "Cancel"
                });

                if (!confirm.isConfirmed) {
                    return; // ❌ Stop submit
                }
            }
        }
        setLoading(true);

        const token = localStorage.getItem('token');
        if (!token) {
            showError('Unauthorized! Please log in again.');
            setLoading(false);
            return;
        }

        try {
            // Map projects array to backend fields
            const mappedProjects = {};
            formData.projects.forEach((p, idx) => {
                const i = idx + 1;
                mappedProjects[`projectTitle${i}`] = p.projectTitle || '';
                mappedProjects[`project${i}Status`] = p.projectStatus || '';
                mappedProjects[`project${i}Score`] = p.projectScore ?? 0;
            });

            const knownSkill = formData.skillsKnown.join(',');

            const payload = {
                mentor: formData.mentorName,
                mentorId: formData.mentorId,
                email_Id: formData.email,
                ProgressStatus: formData.studentProgressStatus,
                companyName: formData.companyName || "",
                companyLocation: formData.companyLocation || "",
                jobRole: formData.jobRole || "",
                placedBy: formData.placedBy || "",
                joiningDate: formData.joiningDate || "",
                placementStatus: formData.placementStatus,
                placementInterest: formData.placementInterest,
                staffRemarks: formData.staffRemarks,
                package: formData.package,
                ...formData,
                ...mappedProjects,
                knownSkill,
            };

            await axios.put(
                `${process.env.REACT_APP_API_URL}/students-record/${id}`,
                payload,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (formData.studentId && formData.email) {
                const regPayload = {
                    email_Id: formData.email,
                    courseType: formData.courseType,
                    course: formData.courseName,
                };

                await axios.put(
                    `${process.env.REACT_APP_API_URL}/registrations/${formData.studentId}`,
                    regPayload,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
            }
            await fetchStudentData();
            showSuccess('Student record updated successfully!');



        } catch (error) {
            console.error("Error updating record:", error);

            if (error.response?.status === 403) {

                await Swal.fire({
                    icon: "error",
                    title: "Access Denied",
                    html: `
 Sorry! You are not authorized to update Placement Details for this record.<br><br>

Placement Status, Placed By, Company Name, Job Role, Package, Placement Date, Joining Date, Company Location, and other placement-related fields cannot be modified once the student is marked as Placed.<br><br>

If any changes are required, please contact <b>Ms. Dharani (9944474154)</b> for approval and complete the Google Form below:<br><br>

<a href="https://docs.google.com/forms/d/e/1FAIpQLSfNPFNvKuUgDgib_BLtPe6Vuk_0AFPkVnc3bZTW-yDOHZCwtw/viewform?usp=sharing&ouid=114637093137229377501" target="_blank">
👉 Click Here to Submit Placement Details Update Request
</a><br><br>

Only Super Admin can update these details.
`,
                    confirmButtonText: "OK"
                });

                // Reload original DB values
                await fetchStudentData();

                return;
            }

            showError("Failed to update record");
        } finally {
            setLoading(false);
        }
    };

    if (!formData) return <div>Loading student data...</div>;

    return (
        <div className="edit-student-wrapper" style={{ display: 'flex', gap: '20px' }}>
            {/* Sidebar */}
            <ProfileSidebar
                studentData={formData}
                onStudentDataUpdate={(updatedData) => setFormData(updatedData)}
            />

            {/* Main Form */}
            <div className="edits-form-container" style={{ flex: 1, minHeight: '100%' }}>
                <div className="tabs-navigation" style={{ display: 'flex', gap: '10px', marginBottom: '15px', overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'thin' }}>
                    <button
                        type="button"
                        className={`tabs-button ${activeTab === 'studentDetails' ? 'active' : ''}`}
                        onClick={() => setActiveTab('studentDetails')}
                        style={{ flexShrink: 0 }}

                    >
                        Student Details
                    </button>
                    <button
                        type="button"
                        className={`tabs-button ${activeTab === 'qualification' ? 'active' : ''}`}
                        onClick={() => setActiveTab('qualification')}

                    >
                        Qualification
                    </button>
                    <button
                        type="button"
                        className={`tabs-button ${activeTab === 'courseDetails' ? 'active' : ''}`}
                        onClick={() => setActiveTab('courseDetails')}
                    >
                        Course Details
                    </button>
                    <button
                        type="button"
                        className={`tabs-button ${activeTab === 'staffDetails' ? 'active' : ''}`}
                        onClick={() => setActiveTab('staffDetails')}
                    >
                        Staff Details
                    </button>

                    <button
                        type="button"
                        className={`tabs-button ${activeTab === 'performance' ? 'active' : ''}`}
                        onClick={() => setActiveTab('performance')}
                    >
                        Performance
                    </button>
                    <button
                        type="button"
                        className={`tabs-button ${activeTab === 'projects' ? 'active' : ''}`}
                        onClick={() => setActiveTab('projects')}
                    >
                        Projects
                    </button>
                    <button
                        type="button"
                        className={`tabs-button ${activeTab === 'placement' ? 'active' : ''}`}
                        onClick={() => setActiveTab('placement')}
                    >
                        Placement
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="form">
                    <div className="tab-content">
                        {activeTab === 'studentDetails' && (
                            <StudentDetails formData={formData}
                                onFormDataChange={setFormData}
                                onDepartmentChange={handleDepartmentChange}
                                onSkillsChange={handleSkillsChange} />
                        )}
                        {activeTab === 'qualification' && (
                            <Qualification formData={formData} />
                        )}
                        {activeTab === 'courseDetails' && (
                            <CourseDetails formData={formData} onFormDataChange={setFormData} />
                        )}
                        {activeTab === 'staffDetails' && (
                            <StaffDetails formData={formData} onFormDataChange={setFormData} />
                        )}

                        {activeTab === 'performance' && (
                            <PerformanceSection formData={formData} onFormDataChange={setFormData} />
                        )}
                        {activeTab === 'projects' && (
                            <>
                                {console.log('Projects in formData:', formData.projects)}
                                <ProjectsSection
                                    formData={formData}
                                    onProjectsChange={(projects) =>
                                        setFormData((prev) => ({ ...prev, projects }))
                                    }
                                />
                            </>
                        )}
                        {activeTab === 'placement' && (
                            <PlacementTab formData={formData} onFormDataChange={setFormData} canUpdateVerification={canUpdateVerification} />
                        )}
                    </div>

                    <div className="form-actions" style={{ marginTop: '20px' }}>
                        <button type="button" onClick={() => navigate(-1)} className="cancel-btn">
                            Cancel
                        </button>
                        <button type="submit" disabled={loading} className="submit-btn">
                            {loading ? 'Updating...' : 'Update'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditStudentRecordpp;
